// JSON-safe sessionStorage access. Swallows failures because Safari private
// mode throws on write and the demo must keep working without persistence.

export function readSession(key, fallback = null) {
    try {
        const raw = sessionStorage.getItem(key);
        return raw === null ? fallback : JSON.parse(raw);
    } catch {
        return fallback;
    }
}

export function writeSession(key, value) {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
        // Persistence is a convenience here, never a correctness requirement.
    }
}
